export { ShippingProtectionPlanDetailsPage as default } from './shipping-protection-page'
